import { useQuery } from '@tanstack/react-query';
import { falconClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import { baseUrl } from '@/data/recommendation/base';
import type { RecommendedActivity } from '@/models/recommendation';

interface RecommendedActivitiesParams {
  activityId: string;
}

export const useRecommendedActivities = ({
  activityId,
}: RecommendedActivitiesParams) => {
  const result = useQuery<RecommendedActivity>({
    enabled: !!activityId,
    queryKey: [clientKeys.useRecommendedActivities, activityId],
    queryFn: async () =>
      await falconClient.get(`${baseUrl}/activities/${activityId}`),
  });

  return { recommendedActivity: result.data || null, ...result };
};
